// Until the app hydrates, a field in server HTML has no React handler, and the
// first render after hydration sets a controlled field back to its `value`, so
// whatever was typed into it is lost. An inline script in _document makes a
// field read-only as soon as it is pressed or focused; App releases the fields
// when it starts rendering, once React's handlers are attached. Read-only rather
// than cancelling input events: Android keyboards type through composition
// events, which can't be cancelled.

declare global {
  interface Window {
    __mtInputGuard?: { release(): void }
  }
}

export function inputGuardScript() {
  return `(function(){var held=[];
function hold(e){var t=e.target;if(t instanceof HTMLElement&&t.matches("input,textarea")&&!t.readOnly){t.readOnly=true;held.push(t)}}
document.addEventListener("pointerdown",hold,true);document.addEventListener("focusin",hold,true);
window.__mtInputGuard={release:function(){document.removeEventListener("pointerdown",hold,true);document.removeEventListener("focusin",hold,true);held.forEach(function(t){t.readOnly=false});held=[]}}})()`
}

export function releaseInputGuard() {
  window.__mtInputGuard?.release()
}
